/**
 * Tishya: play a product card's video while the pointer is over the card.
 *
 * Delegated on the document rather than bound per card, because Horizon
 * re-renders the grid on filter, sort and pagination, and anything bound to
 * the old nodes would be lost.
 *
 * pointerout/pointerover both fire when moving between children of the same
 * card, so each handler bails when relatedTarget is still inside the card.
 * Without that the video restarts every time the cursor crosses the price.
 */
(function () {
  var SEL = '[data-tishya-card-video]';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function cardOf(node) {
    return node && node.closest ? node.closest('.card-gallery') : null;
  }

  function videoIn(card, event) {
    if (!card) return null;
    if (event.relatedTarget && card.contains(event.relatedTarget)) return null;
    return card.querySelector(SEL);
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    if (reduceMotion.matches) return;
    var video = videoIn(cardOf(event.target), event);
    if (!video) return;
    video.muted = true;
    var played = video.play();
    if (played && played.catch) played.catch(function () {});
  });

  document.addEventListener('pointerout', function (event) {
    var video = videoIn(cardOf(event.target), event);
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  });

  /**
   * Touch: play while the card is held, still again the moment it is released.
   *
   * The pointer handlers above deliberately ignore anything that is not a
   * mouse, so touch needs its own pair. A class rather than :hover, because
   * touch browsers leave a sticky :hover behind after a tap and the video
   * would never go back to the still.
   *
   * touchend and touchcancel both report the element the touch STARTED on, so
   * the card is still resolvable even if the finger has since moved off it.
   * Passive listeners throughout: nothing here calls preventDefault, and the
   * card's link must still be free to navigate on a normal tap.
   */
  var TOUCH_CLASS = 'tishya-touch-playing';

  function stopTouch(card) {
    if (!card || !card.classList.contains(TOUCH_CLASS)) return;
    card.classList.remove(TOUCH_CLASS);
    var video = card.querySelector(SEL);
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      if (reduceMotion.matches) return;
      var card = cardOf(event.target);
      if (!card) return;
      var video = card.querySelector(SEL);
      if (!video) return;
      card.classList.add(TOUCH_CLASS);
      video.muted = true;
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
    },
    { passive: true }
  );

  ['touchend', 'touchcancel'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        stopTouch(cardOf(event.target));
      },
      { passive: true }
    );
  });

  /* Belt and braces: a touch that ends outside the card, or is stolen by a
     scroll the browser handles itself, can skip touchend on some engines.
     Any card left playing is reset the next time the page is scrolled. */
  window.addEventListener(
    'scroll',
    function () {
      var stuck = document.querySelectorAll('.' + TOUCH_CLASS);
      for (var i = 0; i < stuck.length; i++) stopTouch(stuck[i]);
    },
    { passive: true }
  );
})();
